import { Fragment, memo } from 'react';
import classNames from 'classnames';
import { Product } from 'shared/types/product/Product';
import FeedbackIconLayer from 'components/gruenland/atoms/button/feedbackIconLayer';
import IntersectionTrigger from 'components/gruenland/atoms/utils/IntersectionTrigger';
import EditorialTile from 'components/gruenland/molecules/editorial-tile/EditorialTile';
import { useFormat } from 'helpers/hooks/useFormat';
import { useProductList } from '../../context';
import PlpProductTileWrapper from '../plp-product-tile-wrapper';

interface Props {
  products: Product[];
}

type ListItemProps = {
  product: Product;
  isSearchResult?: boolean;
};
const ListItem: React.FC<ListItemProps> = memo(function ListItem({ product, isSearchResult }) {
  return <PlpProductTileWrapper product={product} isSearchResult={isSearchResult} />;
});

const List: React.FC<Props> = ({ products }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { searchQuery, loadMore, editorialContent, loading, nextCursor } = useProductList();

  // const loadedAll = useMemo(() => products.length === totalItems, [products, totalItems]);
  const loadedAll = !nextCursor;

  return (
    <div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-16 lg:grid-cols-3 2xl:grid-cols-4 2xl:gap-x-5 2xl:gap-y-20">
        {products.map((product, index) => (
          <Fragment key={product.productId}>
            {(index - 2) % 5 === 0 && editorialContent[(index - 2) / 5 - 1] && (
              <EditorialTile {...editorialContent[(index - 2) / 5 - 1]} />
            )}
            <ListItem product={product} isSearchResult={!!searchQuery} />
          </Fragment>
        ))}
      </div>
      <button
        className={classNames(
          'relative mx-auto mt-[90px] block rounded-md bg-primary-black px-12 py-3 text-[16px] font-medium text-white transition hover:bg-gray-500 disabled:bg-neutral-400',
          { 'opacity-0': loadedAll },
        )}
        disabled={loadedAll || loading}
        onClick={loadMore}
      >
        {loading && <FeedbackIconLayer loading />}
        {formatMessage({ id: 'common.loadMore', defaultMessage: 'Carica altro' })}
      </button>
      {!loading && !loadedAll && <IntersectionTrigger onIntersect={loadMore} />}
    </div>
  );
};

export default List;
